module.exports = __webpack_public_path__ + "gb-nir.5329af5915b425ea338f.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/gb-nir.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/gb-nir.svg
// module chunks = styles